import * as types from '../reducer';
import Service from './service';

const loginUser = (credentials, redirect) => async dispatch => {
  dispatch({ type: types.LOGIN_START });
  try {
    const payload = await Service.login(credentials);
    
    if(payload.user) {
      dispatch({ type: types.LOGIN_SUCCESS, payload });
      redirect && window.location.replace(redirect);
    } else {
      dispatch({ type: types.LOGIN_FAILURE, payload });
    }
  } catch (e) {
    dispatch({ type: types.LOGIN_FAILURE });
    console.error('Failed to login', e);
  }
}

export default loginUser;